import { ProtectedJsonAPI } from './ProtectedJsonAPI'

export const OfferChanges = ProtectedJsonAPI.extend(
  '/offer_changes',
  {
    index:   endpoint => endpoint
  }
)